<div class="cart-product-tile flex-row justify-start align-center gap-10"
  (click)="onEditCartProductClick()">
  <!-- Image -->
  @if (cartProduct.product.image) {
    <div
      class="cart-product-tile-image"
    [ngStyle]="{'background-image': 'url(\'' + cartProduct.product.image?.fullUrl + '\')'}"></div>
  }
  <!-- name && description -->
  <div class="flex-column justify-start align-start">
    <!-- Name-->
    <app-html-content class="cart-product-tile-name"
      [data]="cartProduct.product.name"
    [ellipsis]="55"></app-html-content>
    <div class="cart-product-detail-recap">
      @if (cartProduct) {
        <app-product-recap
        [cartProduct]="cartProduct"></app-product-recap>
      }
    </div>
  </div>
  <!-- price && quantity -->
  <div class="flex-column justify-evenly align-end flex-1 gap-5">
    @if (showZeroPrices || cartProduct.totalPrice > 0) {
      <div class="cart-product-tile-price">
        <app-price [price]="cartProduct.totalPrice"
          [floating]="false"
        [currencyCode]="currencyCode"></app-price>
      </div>
    }
    <div class="cart-product-tile-quantity">x {{ cartProduct.quantity }}</div>
  </div>
</div>

@if (showDivider) {
  <mat-divider class="cart-product-tile-divider"></mat-divider>
}
